<div class="cont-cvu">
    <div class="box-cvu">
        <div class="instructions">
            {{ 'pages.cvu_view.instructions' | translate }}
        </div>
        <br />
        <mat-form-field class="input-yaca cvu-alias-forms">
            <div class="container-input">
                <div>
                    <span class="span-input">{{ tipoCuenta === 'CBU' ? 'CBU' : 'CVU' }}</span>
                </div>
                <input type="text" #cvuInput matInput readonly value="{{ cbuInfo ? cbuInfo : 'Aún no generado' }}" />
                <button mat-icon-button type="button" (click)="copyCvu()" class="buttons">
					<img src="assets/icons/copy-paste.svg" alt="copy" />
				</button>
            </div>
        </mat-form-field>
        <mat-form-field class="input-yaca cvu-alias-forms">
            <div class="container-input">
                <div>
                    <span class="span-input">{{ 'pages.cvu_view.alias' | translate }}</span>
                </div>
                <input type="text" #aliasInput matInput readonly value="{{ aliasInfo ? aliasInfo : 'Aún no generado' }}" />
                <button mat-icon-button type="button" (click)="copyAlias()" class="buttons">
					<img src="assets/icons/copy-paste.svg" alt="copy" />
				</button>
            </div>
        </mat-form-field>
        <!-- <div>
			<button mat-stroked-button color="primary" class="go-back-home" *ngIf="currentUrl()" (click)="goBack()">
				Volver
			</button>
		</div> -->
        <br />
        <br />
        <div class="comprobante" *ngIf="!isMobile">
            <button mat-button (click)="print()">
				Descargar comprobante <img class="img-1" src="assets/icons/descargarCvu.svg" alt="descargarCvu" />
			</button>
        </div>
    </div>
</div>

<div class="comprobanteContainer">
    <div class="comprobanteGenerado">
        <div class="container1">
            <br />
            <!-- cambiar imagem -->
            <img src="assets/icons/fiserv.svg" alt="yacare_comprobante" /><br />
            <span>Comprobante de ALIAS y CVU</span><br />
            <br />
            <hr />
        </div>

        <div class="container2">
            <br />
            <h1>{{ nameLastName }}</h1>
            <span>{{ isCommerce ? 'CUIT :' : 'DNI :' }} {{ cuilCuit }}</span
      ><br /><br />
      <hr />
    </div>
    <div class="container3">
      <br />
      <span>Alias</span> <br />
            <span>{{ aliasInfo }}</span
      ><br /><br />
      <hr />
    </div>

    <div class="container4">
      <br />
      <span>CVU</span> <br />
            <span> {{ cbuInfo }}</span>
            <br /><br />
            <hr />
        </div>

        <div class="container5">
            <br />
            <span>{{ fecha | date: 'd/M/yy' }} - {{ fecha | date: 'H:mm' }}h</span> <br />
            <br />
            <img src="assets/icons/fiserv.svg" alt="yacare_comprobante" />
            <br /><br />
        </div>
    </div>
</div>
